import { css } from '@emotion/react'
import { Checkbox, Text, Tooltip, VFlow } from 'bold-ui'
import { CriticidadeAlergia, ReceitaMedicamentoSdcDto } from 'graphql/types.generated'
import { AlergiaPrincipioAtivoAlert } from 'view/atendimentos/detail/acompanhamentos/pre-natal/components/AlergiaPrincipioAtivoAlert'

interface PrescricaoSdcProps {
  prescricao: ReceitaMedicamentoSdcDto
  handleTogglePrescricao: (prescricao: ReceitaMedicamentoSdcDto) => void
  dataTestId?: string
  idadeCidadaoEmAnos: number
  isAlergico: boolean
  criticidade: CriticidadeAlergia
}
export function PrescricaoSdcCheckbox(props: Readonly<PrescricaoSdcProps>) {
  const { prescricao, handleTogglePrescricao, dataTestId, idadeCidadaoEmAnos, criticidade, isAlergico } = props
  const { medicamentoCatmat, motivoRestricaoPrescricao, prescrever, unidadeMedidaDose } = prescricao

  const { principioAtivo, concentracao } = medicamentoCatmat?.medicamento ?? {}

  return (
    <Tooltip text={motivoRestricaoPrescricao ?? ''}>
      <VFlow vSpacing={0.25} data-testid={dataTestId}>
        <Checkbox
          label={`${principioAtivo} ${concentracao?.replace('ml', 'mL')} ${
            unidadeMedidaDose?.nomePlural && `em ${unidadeMedidaDose?.nomePlural.toLowerCase()}`
          }`}
          disabled={!prescrever}
          onChange={() => handleTogglePrescricao(prescricao)}
        />
        {prescricao.medicamentoCatmat?.codigoCatMat === 'BR0268390' && idadeCidadaoEmAnos >= 13 && (
          <Text style={styles.offset} variant='disabled'>
            De acordo com o peso do cidadão
          </Text>
        )}
        {isAlergico && <AlergiaPrincipioAtivoAlert style={styles.offset} criticidade={criticidade} />}
      </VFlow>
    </Tooltip>
  )
}

const styles = {
  offset: css`
    margin-left: 2.25rem;
  `,
}
